module.exports = __webpack_public_path__ + "img/wedbook-ffffff.ed29a31a.svg";